import store from "@/store/index";

export interface AppPlayerTrainingsRootListFormCreate {
  user_id: string;
  organization_id: string;
  training_category_id: string;
  content: {
    date: string;
    fields: any;
  };
}

export class AppPlayerTrainingsRootListFormCreate implements AppPlayerTrainingsRootListFormCreate {
  user_id: string;
  organization_id: string;
  training_category_id: string;
  content: {
    date: string;
    fields: any;
  };

  constructor() {
    this.user_id = store.getters.getAuthentication.id ?? "";
    this.organization_id = store.getters.getOrganizationMember.organization_id ?? "";
    this.training_category_id = "";
    this.content = {
      date: "",
      fields: [],
    };
  }
}